<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${deviceId ? 'Edit' : 'Add New'} Device`" />

    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="deviceId" class="custom-label">ID</label>
            <input id="deviceId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-9 mb-3">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="custom-label">Device Type</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.devicetypeid">
              <option v-for="deviceType in deviceTypes" :key="deviceType.uuid" :value="deviceType.uuid">{{
                deviceType.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="custom-label">Asset</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.assetid">
              <option v-for="asset in assets" :key="asset.uuid" :value="asset.uuid">{{ asset.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="custom-label">Component</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.componentid">
              <option v-for="component in components" :key="component.uuid" :value="component.uuid">{{ component.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="custom-label">Hub</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.hubid">
              <option v-for="hub in hubs" :key="hub.uuid" :value="hub.uuid">{{ hub.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeDesc" class="custom-label">Description</label>
            <input id="assetTypeDesc" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" rows="4" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.deviceId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>
        <deleteModal v-if="this.deviceId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.deviceId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button" @click="addDeviceData()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { addDevice, getByDevice, ddAsset, ddHub, ddComponent, ddDeviceType, updateDevice } from '@/http/hub-sensors/device.http'
import deleteModal from '@/components/delete-modal.vue';
export default {
  name: 'device-form',
  components: {
    Header,
    Subheader,
    deleteModal
  },
  data() {
    return {
      breadcrumsfirst: "Hub & Sensors",
      breadcrumslast: "Device",
      deviceId: this.$route.params.id,
      saveData: {},
      deviceTypes: [],
      components: [],
      hubs: []
    }
  },
  async mounted() {
    await this.getAssetDropdownData();
    await this.getCompDropdownData();
    await this.getHubDropdownData();
    await this.getDeviceTypeDropdownData();
    await this.getDetailData();
  },
  methods: {
    addDeviceData() {
      if (this.deviceId) {
        const payload = {
          uuid: this.$route.params.id,
        };
        updateDevice({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/hubsensors/device")
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        addDevice(this.saveData).then(() => {
          this.$router.push("/hubsensors/device")
        }).catch((error) => {
          this.error = error.message;
        });
      }

    },

    async getDeviceTypeDropdownData() {
      try {
        const response = await ddDeviceType();
        this.deviceTypes = response;
        if (this.deviceTypes.length > 0) {
          if (this.deviceId) {
            const index = this.deviceTypes.findIndex(deviceType => deviceType.uuid === this.saveData.devicetypeid);
            if (index !== -1) {
              this.saveData.devicetypeid = this.deviceTypes[index].uuid;
            }
          } else {
            this.saveData.devicetypeid = this.deviceTypes[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching Device Type:', error);
      }
    },
    async getAssetDropdownData() {
      try {
        const response = await ddAsset();
        this.assets = response;
        if (this.assets.length > 0) {
          if (this.deviceId) {
            const index = this.assets.findIndex(asset => asset.uuid === this.saveData.assetid);
            if (index !== -1) {
              this.saveData.assetid = this.assets[index].uuid;
            }
          } else {
            this.saveData.assetid = this.assets[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching Asset:', error);
      }
    },
    async getCompDropdownData() {
      try {
        const response = await ddComponent();
        this.components = response;
        if (this.components.length > 0) {
          if (this.deviceId) {
            const index = this.components.findIndex(comp => comp.uuid === this.saveData.componentid);
            if (index !== -1) {
              this.saveData.componentid = this.components[index].uuid;
            }
          } else {
            this.saveData.componentid = this.components[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching Component:', error);
      }
    },
    async getHubDropdownData() {
      try {
        const response = await ddHub();
        this.hubs = response;
        if (this.hubs.length > 0) {
          if (this.deviceId) {
            const index = this.hubs.findIndex(hub => hub.uuid === this.saveData.hubid);
            if (index !== -1) {
              this.saveData.hubid = this.hubs[index].uuid;
            }
          } else {
            this.saveData.hubid = this.hubs[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching Hub:', error);
      }
    },
    async getDetailData() {
      if (this.deviceId) {
        try {
          const response = await getByDevice(this.deviceId);
          this.saveData = response;
          this.saveData.devicetypeid = response.devicetypeid;
          this.saveData.componentid = response.componentid;
          this.saveData.hubid = response.hubid;
          this.saveData.assetid = response.assetid;
        } catch (error) {
          console.error('Error fetching detail data:', error);
        }
      }
    },
    cancelButton() {
      this.$router.push("/hubsensors/device")
    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      updateDevice({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/hubsensors/device")
      }).catch((error) => {
        this.error = error.message;
      });

    },
  }
}
</script>

<style scoped></style>